module.exports = __webpack_public_path__ + "static/media/Progen-01.30368783.jpg";